import { ClientHandler } from '../../../types/client-handler';

import { getMacroSacaTuTarjetaHelpers } from '../../../constants/clients/MACRO/saca-tu-tarjeta/helpers';

const macroSacaTuTarjetaHelpers = getMacroSacaTuTarjetaHelpers();

export const macroHandler: ClientHandler = {
  applyFieldLogic: (fieldKey: string, value: any, formData: any) => {
    const creativityType = formData._creativityType;

    if (creativityType === 'macro-saca-tu-tarjeta') {
      return macroSacaTuTarjetaHelpers.applyFieldLogic(fieldKey, value, formData);
    }

    return {};
  },

  shouldShowField: (fieldKey: string, formData: any, creativityType: string) => {
    if (creativityType === 'macro-saca-tu-tarjeta') {
      return macroSacaTuTarjetaHelpers.shouldShowField(fieldKey, formData, creativityType);
    }

    // Para otros templates de MACRO, mostrar todos los campos
    return true;
  },

  validateForm: (formData: any, baseErrors: Record<string, string>) => {
    // Inferir del formData si no viene _creativityType
    const creativityType = formData._creativityType;

    if (creativityType === 'macro-saca-tu-tarjeta') {
      const customErrors = macroSacaTuTarjetaHelpers.validateForm(formData);
      return { ...baseErrors, ...customErrors };
    }

    return baseErrors;
  },

  getDynamicOptions: (fieldKey: string, formData: any, baseOptions: any[]) => {
    const creativityType = formData._creativityType;

    if (creativityType === 'macro-saca-tu-tarjeta') {
      return macroSacaTuTarjetaHelpers.getDynamicOptions(fieldKey, formData, baseOptions);
    }

    return undefined;
  },

  getDemoPreviews: (formData: any, creativityType: string) => {
    if (creativityType === 'macro-saca-tu-tarjeta') {
      return macroSacaTuTarjetaHelpers.getDemoPreviews(formData);
    }

    return {};
  }
};
